import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdiomaService } from 'src/app/services/idioma.service';

@Component({
  selector: 'app-paginador',
  templateUrl: './paginador.component.html',
  styleUrls: ['./paginador.component.css']
})
export class PaginadorComponent implements OnInit, OnDestroy {

  @Input() pagina: number = 1;
  @Input() totalPaginas: number = 0;
  @Input() totalRegistros: number = 0;
  @Input() registrosPorPagina: number = 50;
  @Input() opcionesRegistros: number[] = [50, 150, 250];

  @Output() irAPagina = new EventEmitter<number>();
  @Output() cambiarRegistrosPorPagina = new EventEmitter<number>();

  public t: any;
  private subscripcionTextos: Subscription;

  constructor(private _idioma: IdiomaService) { }

  ngOnInit(): void {
    this.subscripcionTextos = this._idioma.getTextos$().subscribe(texto => {
      this.t = texto;
    });
  }

  ngOnDestroy(): void {
    if (this.subscripcionTextos) {
      this.subscripcionTextos.unsubscribe();
    }
  }

  get hayAnterior(): boolean {
    return this.pagina > 1;
  }

  get haySiguiente(): boolean {
    return this.pagina < this.totalPaginas;
  }

  onPrimera(): void {
    if (this.hayAnterior) { this.irAPagina.emit(1); }
  }

  onAnterior(): void {
    if (this.hayAnterior) { this.irAPagina.emit(this.pagina - 1); }
  }

  onSiguiente(): void {
    if (this.haySiguiente) { this.irAPagina.emit(this.pagina + 1); }
  }

  onUltima(): void {
    if (this.haySiguiente) { this.irAPagina.emit(this.totalPaginas); }
  }

  onCambiarRegistros(valor: number): void {
    this.cambiarRegistrosPorPagina.emit(Number(valor));
  }
}
